import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://freelance-connect.vercel.app/api/KaamhubConnectwebsite';

const api = axios.create({
  baseURL: API_BASE,
});

export const fetchStats = async () => {
  const { data } = await api.get('/stats');
  return data;
};

export default api;
